import slice from '../slice.js';

export default function dropLastWhile(pred, xs) {
  var idx = xs.length - 1;
  while (idx >= 0 && pred(xs[idx])) {
    idx -= 1;
  }
  return slice(0, idx + 1, xs);
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_dropLastWhile.js
// module id = 8771
// module chunks = 2